import { requiredStringSchema, validate } from '.';

const tokenNameFormatMessage = 'Token names must be no more than 32 characters.';
const tokenNameSchema = requiredStringSchema.max(32, tokenNameFormatMessage);

export function validateTokenName(name: string): string {
  return validate(tokenNameSchema, name);
}
